module.exports = __webpack_public_path__ + "img/playbutton9.61cf91d1.png";